import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataTableModule } from './../../components/common/datatables/datatable.module';
import { ModalModule } from 'ng2-bootstrap';

import {RoleComponent} from "./role.component";
import {RoleEditorModule} from "./role-editor/role-editor.module";


@NgModule({
    declarations: [RoleComponent],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        DataTableModule,
        ModalModule,
        RoleEditorModule,
        BrowserModule
    ]
})

export class RoleModule {}


// WEBPACK FOOTER //
// ./src/app/views/role/role.module.ts